// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardSchedulingConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------
//

import localizer from 'share/localization/Izenda.Localizer';

export default {
  get SCHEDULE_REPORT() {
    return localizer.getText('DASHBOARD_SCHEDULING_CONSTANTS_SCHEDULE_REPORT');
  },
  get SEARCH_OPTION() {
    return [
      { value: 'All', label: localizer.getText('COMMON_LABEL_ALL') },
      { value: 'Name', label: localizer.getText('COMMON_LABEL_INSTANCE_NAME') },
      { value: 'Type', label: localizer.getText('COMMON_LABEL_TYPE') },
      { value: 'Schedule', label: localizer.getText('COMMON_LABEL_SCHEDULE') },
      { value: 'FilterValueSelection', label: localizer.getText('COMMON_LABEL_FILTER_VALUE_SELECTION') },
      { value: 'DeliveryType', label: localizer.getText('COMMON_LABEL_DELIVERY_TYPE') },
      { value: 'DeliveryMethod', label: localizer.getText('COMMON_LABEL_DELIVERY_METHOD') },
      { value: 'Recipients', label: localizer.getText('DASHBOARD_SCHEDULING_CONSTANTS_TABLE_DEF_TITLE_RECIPIENTS') },
      {
        value: 'LastSuccessfulRun',
        label: localizer.getText('DASHBOARD_SCHEDULING_CONSTANTS_TABLE_DEF_TITLE_LAST_SUCCESS_RUN')
      },
      {
        value: 'NextScheduledRun',
        label: localizer.getText('DASHBOARD_SCHEDULING_CONSTANTS_TABLE_DEF_TITLE_NEXT_SCHEDULED_RUN')
      }
    ];
  },
  get SCHEDULE_TYPE() {
    return [
      {
        value: 'Scheduled Reporting Item',
        label: localizer.getText('DASHBOARD_SCHEDULING_CONSTANTS_SCHEDULE_TYPE_LABEL_REPORTING_ITEM')
      },
      {
        value: 'Scheduled Alert',
        label: localizer.getText('DASHBOARD_SCHEDULING_CONSTANTS_SCHEDULE_TYPE_LABEL_SCHEDULED_ALERT')
      }
    ];
  },
  get SCHEDULE_TYPE_VALUES() {
    return {
      scheduleReport: localizer.getText('DASHBOARD_SCHEDULING_CONSTANTS_SCHEDULE_TYPE_VALUES_SCHEDULE_REPORT'),
      scheduleAlert: localizer.getText('DASHBOARD_SCHEDULING_CONSTANTS_SCHEDULE_TYPE_VALUES_SCHEDULE_ALERT')
    };
  },
  get PAGE_TEXT() {
    return {
      AddText: localizer.getText('DASHBOARD_SCHEDULING_CONSTANTS_PAGE_TEXT_ADD'),
      EditText: localizer.getText('DASHBOARD_SCHEDULING_CONSTANTS_PAGE_TEXT_EDIT'),
      CopyText: localizer.getText('DASHBOARD_SCHEDULING_CONSTANTS_PAGE_TEXT_COPY'),
      DeleteText: localizer.getText('DASHBOARD_SCHEDULING_CONSTANTS_PAGE_TEXT_DELETE')
    };
  },

  get TABLE_DEF() {
    return {
      selectedValue: { key: 'selectedValue', width: 30, title: '', sortable: false },
      name: {
        key: 'name',
        width: 150,
        title: localizer.getText('COMMON_LABEL_INSTANCE_NAME'),
        sortable: true,
        columnKey: 'name'
      },
      type: {
        key: 'type',
        width: 100,
        title: localizer.getText('COMMON_LABEL_TYPE'),
        sortable: true,
        columnKey: 'type'
      },
      schedule: {
        key: 'schedule',
        width: 180,
        title: localizer.getText('COMMON_LABEL_SCHEDULE'),
        sortable: true,
        columnKey: 'schedule'
      },
      filterValueSelection: {
        key: 'filterValueSelection',
        width: 180,
        title: localizer.getText('COMMON_LABEL_FILTER_VALUE_SELECTION'),
        sortable: true,
        columnKey: 'filterValueSelection'
      },
      deliveryType: {
        key: 'deliveryType',
        width: 150,
        title: localizer.getText('COMMON_LABEL_DELIVERY_TYPE'),
        sortable: true,
        columnKey: 'deliveryType'
      },
      deliveryMethodView: {
        key: 'deliveryMethodView',
        width: 150,
        title: localizer.getText('COMMON_LABEL_DELIVERY_METHOD'),
        sortable: true,
        columnKey: 'deliveryMethodView'
      },
      recipients: {
        key: 'recipients',
        width: 120,
        title: localizer.getText('DASHBOARD_SCHEDULING_CONSTANTS_TABLE_DEF_TITLE_RECIPIENTS'),
        sortable: true,
        columnKey: 'recipients'
      },
      lastSuccessfulRun: {
        key: 'lastSuccessfulRun',
        width: 180,
        title: localizer.getText('DASHBOARD_SCHEDULING_CONSTANTS_TABLE_DEF_TITLE_LAST_SUCCESS_RUN'),
        sortable: true,
        columnKey: 'lastSuccessfulRun'
      },
      nextScheduledRun: {
        key: 'nextScheduledRun',
        width: 180,
        title: localizer.getText('DASHBOARD_SCHEDULING_CONSTANTS_TABLE_DEF_TITLE_NEXT_SCHEDULED_RUN'),
        sortable: true,
        columnKey: 'nextScheduledRun'
      },
      action: {
        key: 'action',
        width: 80,
        title: localizer.getText('COMMON_LABEL_ACTION'),
        sortable: false,
        fixed: true
      }
    };
  },
  get MESSAGE() {
    return {
      M01a: localizer.getText('DASHBOARD_SCHEDULING_CONSTANTS_MESSAGE_DELETE_SCHEDULE_INSTANTCE'),
      M01b: localizer.getText('DASHBOARD_SCHEDULING_CONSTANTS_MESSAGE_DELETE_SELECTED_SCHEDULE_INSTANTCE')
    };
  },
  get CONTRAINTS() {
    return {
      RECIPIENTS: {
        presence: {
          presence: true,
          message: localizer.getText('DASHBOARD_SCHEDULING_CONSTANTS_CONTRAINTS_MESSAGE_RECIPIENTS_IS_REQUIRE')
        }
      }
    };
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.DashboardSchedulingConstants.js